module.exports = __webpack_public_path__ + "static/media/Manuel Salinas Zapata.3d0859fd.jpg";